export const maxPathDepth = 3;
